import React from 'react';

import { lang, remCss, scssVariables as variables } from 'src/helpers';
import { Puff } from 'react-loader-spinner';

export const RadioField = React.memo(
  ({
    checked,
    onChange,
    label,
    template,
    style,
    onClick = () => {},
    loading = false,
    shape = 'round'
  }) => {
    return (
      <div
        className={
          `mc-checkbox-field ${shape} template-` + template + ' ' + (checked ? 'checked' : '')
        }
        style={style}
        onClick={onClick}
      >
        <label>
          <input
            type='radio'
            hidden
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
          {loading ? (
            <div className='checkmark loading'>
              <Puff color={variables['colors-mc-primary']} height={remCss(28)} width={remCss(28)} />
            </div>
          ) : (
            <span className='checkmark' />
          )}
          {lang.t(label)}
        </label>
      </div>
    );
  }
);
RadioField.displayName = 'RadioField';

export const RadiosField = React.memo(({ list, data, onChange, template = '1', shape }) => {
  return list.map((item, index) => (
    <RadioField
      key={'radio-' + index}
      label={item.label}
      checked={data === item.value}
      template={template}
      onChange={() => {
        onChange(item.value);
      }}
      loading={item.loading}
      shape={shape}
    />
  ));
});
RadiosField.displayName = 'RadiosField';
